import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { JSX } from 'react'

import { AlertRulesScreen } from './-components/alert-rules-screen.tsx'

export const Route = createFileRoute('/alerts/rules')({
  component: AlertRulesPage
})

function AlertRulesPage(): JSX.Element {
  const navigate = useNavigate()

  return (
    <AlertRulesScreen
      onOpenView={link => {
        const url = new URL(link, window.location.origin)
        void navigate({ href: `${url.pathname}${url.search}` })
      }}
    />
  )
}
